import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useIdentity } from '../../hooks/useIdentity';

const Authorize = (): ReactElement => {
    const [token, isAuthenticated, updateToken] = useIdentity();

    return (
        <>
            {!isAuthenticated && <Navigate to={'/'}/>}
        </>
    );
};

export default Authorize;